import { useState, useEffect, useRef } from 'react';

export function useCallSession() {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(0);
  const [conversationId, setConversationId] = useState<string | null>(null);
  const timerIntervalRef = useRef<NodeJS.Timeout | null>(null);

  // Timer functionality
  useEffect(() => {
    if (isActive) {
      timerIntervalRef.current = setInterval(() => {
        setTimer(prev => prev + 1);
      }, 1000);
    } else {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    }
    return () => {
      if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    };
  }, [isActive]);

  const startSession = () => {
    setIsActive(true);
    setTimer(0);
    // Don't reset conversation ID - it should persist across interactions
  };

  const endSession = () => {
    setConversationId(null);
    setIsActive(false);
    setTimer(0);
  };

  const formatTimer = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };


  return {
    timer,
    conversationId,
    setConversationId,
    isActive,
    formatTimer,
    startSession,
    endSession
  };
} 